import MenuBgSvg from '../svgs/MenuBgSvg2';
import {
    getROC,
    getEquityRiskCharge,
    getPropertyRiskCharge,
    getInterestRateRiskCharge,
    getCreditSpreadRiskCharge,
    getNewBusinessInvestment,
    getInsuranceRisk,
    getPCR,
    getTotalLiabilities,
    getTotalAssets,
    getSurplus,
    numberWithCommas,
    getInterestRateRiskExposure,
    getCreditSpreadRiskExposure,
    getEquityRiskExposure,
    getPropertyRiskExposure,
    getCurrencyRiskExposure,
    getMarketRisk,
    getCurrencyRiskCharge,
    getTVOGDown,
    getTVOGDownInMil,
    getTVOGMid,
    getTVOGMidInMil,
    getTVOGUp,
    getTVOGUpInMil,
    getTVOG
} from '../gameUtil'
import { PieChart } from 'react-minimal-pie-chart';
import { useState } from 'react';

export default function Component({player,data,turn,event=null}){

    const [selected ,setSelected]=useState(null)
    return(
        <div style={{position:'relative',flex:1,height:'100%',justifyContent:'flex-start',alignItems:'flex-start',boxSizing:'border-box'}}>
            <MenuBgSvg width={"min( 80svh/ 1080 * 1920, 80svw)"} style={{position:"absolute",top:'11%',left:0}}/>
            <div style={{position:"absolute",top:'13%',left:'10%',fontSize:`min(2vw, ${2/1080*1920}vh )`,fontWeight:"700"}}>
                TVOG [simplified] 
            </div>
            <div style={{position:'absolute',top:'22%',bottom:'23%',left:'6%',right:'15%',display:'flex',flexDirection:'row',gap:'2%'}}>
                <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',flex:5,borderLeft:'2px solid #FF7272',boxSizing:"border-box"}}>
                    <div style={{width:'100%',color:"white",textAlign:'left',boxSizing:"border-box",height:'min(4vw, 4/1080*1920vh )',fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:"700",display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center',gap:'2%'}}>
                        <div style={{flex:3,backgroundColor:'#FF7272',height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',paddingLeft:'min(2vw, 2/1080*1920vh)'}}>
                            End of Year {Math.floor((turn)/2)+1}
                        </div>
                        <div style={{flex:2,backgroundColor:'#FF7272',height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}>
                            Tvog related to asset return
                        </div>
                        <div style={{flex:2,backgroundColor:'#FF7272',height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}>
                            TVOG in million
                        </div>
                    </div>
                    <div style={{height:'100%',width:'100%',boxSizing:'border-box',display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'flex-start',fontSize:`min(1.3vw, ${1.3/1080*1920}vh )`,fontWeight:"700",boxSizing:'border-box'}}>
                        <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'2%'}}>
                            <div style={{flex:3,height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',paddingLeft:'min(2vw, 2/1080*1920vh)'}}>
                                <div style={{width:'100%',boxSizing:'border-box',textAlign:'left',borderBottom:'1px solid black',paddingBottom:'min(1.4vw, 1.4/1080*1920vh)',paddingTop:'min(1.4vw, 1.4/1080*1920vh)'}}>
                                    Down
                                </div>
                            </div>
                            <div style={{flex:2,height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'flex-end',borderBottom:'1px solid black',textAlign:'right',paddingBottom:'min(1.4vw, 1.4/1080*1920vh)',paddingTop:'min(1.4vw, 1.4/1080*1920vh)'}}>
                                {numberWithCommas(Math.round(getTVOGDown(player,turn,event)*10000)/100)} %
                            </div>
                            <div style={{flex:2,height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'flex-end',borderBottom:'1px solid black',textAlign:'right',paddingBottom:'min(1.4vw, 1.4/1080*1920vh)',paddingTop:'min(1.4vw, 1.4/1080*1920vh)'}}>
                                {numberWithCommas(Math.round(getTVOGDownInMil(player,turn,event)*100)/100||0)} mil
                            </div>
                        </div>

                        <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'2%'}}>
                            <div style={{flex:3,height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',paddingLeft:'min(2vw, 2/1080*1920vh)'}}>
                                <div style={{width:'100%',boxSizing:'border-box',textAlign:'left',borderBottom:'1px solid black',paddingBottom:'min(1.4vw, 1.4/1080*1920vh)',paddingTop:'min(1.4vw, 1.4/1080*1920vh)'}}>
                                    Mid
                                </div>
                            </div>
                            <div style={{flex:2,height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'flex-end',borderBottom:'1px solid black',textAlign:'right',paddingBottom:'min(1.4vw, 1.4/1080*1920vh)',paddingTop:'min(1.4vw, 1.4/1080*1920vh)'}}>
                                {numberWithCommas(Math.round(getTVOGMid(player,turn,event)*10000)/100)} %
                            </div>
                            <div style={{flex:2,height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'flex-end',borderBottom:'1px solid black',textAlign:'right',paddingBottom:'min(1.4vw, 1.4/1080*1920vh)',paddingTop:'min(1.4vw, 1.4/1080*1920vh)'}}>
                                {numberWithCommas(Math.round(getTVOGMidInMil(player,turn,event)*100)/100||0)} mil
                            </div>
                        </div>
                        <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'2%'}}>
                            <div style={{flex:3,height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',paddingLeft:'min(2vw, 2/1080*1920vh)'}}>
                                <div style={{width:'100%',boxSizing:'border-box',textAlign:'left',borderBottom:'1px solid black',paddingBottom:'min(1.4vw, 1.4/1080*1920vh)',paddingTop:'min(1.4vw, 1.4/1080*1920vh)'}}>
                                    Up
                                </div>
                            </div>
                            <div style={{flex:2,height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'flex-end',borderBottom:'1px solid black',textAlign:'right',paddingBottom:'min(1.4vw, 1.4/1080*1920vh)',paddingTop:'min(1.4vw, 1.4/1080*1920vh)'}}>
                                {numberWithCommas(Math.round(getTVOGUp(player,turn,event)*10000)/100)} %
                            </div>
                            <div style={{flex:2,height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'flex-end',borderBottom:'1px solid black',textAlign:'right',paddingBottom:'min(1.4vw, 1.4/1080*1920vh)',paddingTop:'min(1.4vw, 1.4/1080*1920vh)'}}>
                                {numberWithCommas(Math.round(getTVOGUpInMil(player,turn,event)*100)/100||0)} mil
                            </div>
                        </div>
                        

                        


                        <div style={{width:'100%',display:'flex',flexDirection:'row',justifyContent:'flex-start',alignItems:'center',gap:'2%',color:'#DB3535',fontSize:`min(1.5vw, ${1.5/1080*1920}vh )`}}>
                            <div style={{flex:5,height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',paddingLeft:'min(2vw, 2/1080*1920vh)'}}>
                                <div style={{width:'100%',boxSizing:'border-box',textAlign:'left',paddingBottom:'min(1.4vw, 1.4/1080*1920vh)',paddingTop:'min(1.4vw, 1.4/1080*1920vh)'}}>
                                    TVOG
                                </div>
                            </div>
                            <div style={{flex:2,height:'100%',boxSizing:'border-box',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'flex-end',textAlign:'right',paddingBottom:'min(1.4vw, 1.4/1080*1920vh)',paddingTop:'min(1.4vw, 1.4/1080*1920vh)'}}>
                                {numberWithCommas(Math.round(getTVOG(player,turn,event)*100)/100||0)} mil
                            </div>
                        </div>
                        
                    </div>
                </div>
               
                    

            </div>
        </div>
    );
}